import { ReactElement } from 'react';

import { ICategory } from '@Hotels-at-Home/hah-fe-core/dist/types/category';
import get from 'lodash/get';
import classNames from 'classnames';

interface IProps {
  category: ICategory;
}

const CategorySEO = ({ category }: IProps): ReactElement => {
  const seoCopy = category.seo_copy || [];
  const imgWidth = category.seo_copy_image_width || null;
  const imgHeight = category.seo_copy_image_height || null;

  const title = get(seoCopy, [0, 'value'], '');
  const imgAltText = title?.replace(/<[^>]*>?/gm, '');
  const description = get(seoCopy, [3, 'value'], '');
  const imgUrl = get(seoCopy, [2, 'value'], '');
  const imgUrlMobile = category?.seo_copy_image_mobile;

  if (!title || !description || !imgUrl) {
    return null;
  }

  return (
    <section className={classNames('seo', imgUrlMobile ? 'has-mobile-image' : 'no-mobile-image')}>
      <div className="seo-stack">
        <span className="icon-link" />
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <picture>
        {/* TODO: We need to load the webp image after it's added to the API response */}
        {imgUrlMobile && <source media="(max-width: 660px)" data-srcset={imgUrlMobile} />}
        <img alt={imgAltText} src={imgUrl} width={imgWidth} height={imgHeight} loading="lazy" />
      </picture>
    </section>
  );
};

export default CategorySEO;
